<div fxLayoutGap="24px" fxLayout="column" fxLayoutAlign="start center" mat-dialog-content>

  <img src="../../assets/images/logos/ls-premium.png"
       alt="Little SIS Premium logo" class="logo">

  <div fxLayout="column" [ngClass] = "{'red-600-fg': templateData.showIcon}"
       fxLayoutAlign="start center" class="license-info-panel">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
      <mat-icon *ngIf="templateData.showIcon" class="icon-20">warning</mat-icon>
      <p class="centered" [innerHTML]="templateData.expiryMessage | safe: 'html'"></p>
    </div>
    <p>{{templateData.expireDate}}</p>
  </div>

</div>

<div [fxLayoutAlign]="(templateData.expireDays > 7) ? 'space-between center':'end center'" mat-dialog-actions>
  <mat-checkbox *ngIf="templateData.expireDays > 7"  (change)="toggleReminder($event)" [(ngModel)]="muteNotification">Do not show me this again</mat-checkbox>
  <button class="close-button" mat-button (click)="closeDialog()">CLOSE</button>
</div>
